// Утилиты для работы с геолокациями

/**
 * Формула Haversine для расчета расстояния между двумя точками на Земле
 * Возвращает расстояние в километрах
 */
export function calculateDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371; // Радиус Земли в км
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
    Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Константы для кэширования
export const CACHE_KEY = 'pharmacy_locations_cache_v3'; // v3 - нормализация lowercase username
export const CACHE_TTL = 5 * 60 * 1000; // 5 минут

/**
 * Форматирует телефон для WhatsApp ссылки
 * Убирает все символы кроме цифр и конвертирует 8 в 7
 * @param phone - номер телефона в любом формате
 * @returns отформатированный номер для WhatsApp
 */
export function formatPhoneForWhatsApp(phone: string): string {
  // Убираем все кроме цифр
  const cleaned = phone.replace(/\D/g, '');
  // Если начинается с 8, заменяем на 7
  return cleaned.startsWith('8') ? '7' + cleaned.slice(1) : cleaned;
}

